window.kontotypes = window.kontotypes || {};
kontotypes.vp = kontotypes.vp || {};

kontotypes.vp.RacunIspis = {
	RACUN: "Racun",
	PONUDA: "Ponuda",
	PRIJEPIS: "Prijepis"
};

kontotypes.vp.TipRacuna = {
	OBICAN: "Obican",
	STORNO: "Storno"
};